import { Action, createReducer, on } from "@ngrx/store";
import { loggedUserSuccess } from "./auth-user-actions";
import {UserInterface} from '@core/model/user/user.interface';


export interface AuthUserState {
  user: UserInterface;
}

export const initialState: AuthUserState ={
  user: null
}

const authUserReducer = createReducer(
  initialState,
  on(loggedUserSuccess, (state, { user }) => ({ ...state, user: user })),
);

export function reducer(state: AuthUserState | undefined, action: Action) {
  return authUserReducer(state, action);
}
